function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BruneiDarussalamFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#FFD221",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#313131",
        d: "m-2.3 10.961 1.506-3.434 26.12 11.454-1.506 3.434L-2.3 10.961Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#FAF9F9",
        d: "m-2.263 7.177 1.505-3.434 27.42 12.017-1.506 3.435L-2.263 7.177Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#CF1225",
        fillRule: "evenodd",
        d: "M12 5.165a.75.75 0 0 0-.75.75v2.722a2.192 2.192 0 0 0-.951-.237c-.823 0-1.749 1.152-1.749 1.152s1.53.042 2.7 1.203v4.16c-1.295-.342-1.85-1.66-1.705-4.354L7.3 10.439c-.235 4.325 1.363 6.819 4.732 6.819 3.352 0 5.005-2.47 4.894-6.787l-2.25.058c.072 2.751-.556 4.086-1.925 4.403v-4.318c1.147-1.024 2.55-1.062 2.55-1.062S14.374 8.4 13.551 8.4c-.297 0-.571.074-.801.17V5.914a.75.75 0 0 0-.75-.75Zm-7.635 6.073a.75.75 0 0 1 .27-1.476c1.498.274 2.313 1.317 2.313 2.911v3.038a.75.75 0 0 1-1.5 0v-3.038c0-.889-.317-1.295-1.083-1.435Zm15.92-.873a.75.75 0 0 1-.602.873c-.766.14-1.083.546-1.083 1.435v3.038a.75.75 0 0 1-1.5 0v-3.038c0-1.594.814-2.637 2.313-2.91a.75.75 0 0 1 .873.602ZM7.306 16.83l1.24-.845c.695 1.02 1.817 1.531 3.455 1.531 1.649 0 2.69-.398 3.2-1.138l1.234.852c-.835 1.21-2.34 1.786-4.434 1.786-2.106 0-3.7-.727-4.694-2.186Z",
        clipRule: "evenodd"
      })]
    })]
  })]
}));
//# sourceMappingURL=BruneiDarussalam.js.map